import * as React from 'react';
import { Container } from '../../../components/web/container/container';
import { WebButton } from '../../../components/web/button/web-button';
import { IconFacebook } from '../../../components/app/icons/facebook';
import { IconInstagram } from '../../../components/app/icons/instagram';
import { IconDiscord } from '../../../components/app/icons/discord';
import { IconCanny } from '../../../components/app/icons/canny';
import { IconGuide } from '../../../components/app/icons/guide';

import { IconNext } from '../../../components/app/icons/next';
import styles from './contact.module.css';

interface ContactRowProps {
    title: string;
    description: string;
    href?: string;
    icon: React.ReactNode;
    action: string;
    primary?: boolean;
}

const ContactRow = ({ title, description, href, icon, action, primary = false }: ContactRowProps) => (
    <article className={styles.row}>
        <span aria-hidden="true" className={styles.icon}>
            {icon}
        </span>
        <div className="min-w-0">
            <h2 className="text-[2.8rem] font-semibold leading-[1.15] tracking-[-0.025em] text-brand-secondary md:text-[3.6rem]">
                {title}
            </h2>
            <p className="mt-[1.2rem] max-w-[57rem] text-[1.7rem] leading-[1.6] text-web-copy">{description}</p>
        </div>
        <div className={styles.action}>
            <WebButton
                href={href}
                variant={primary ? 'primary' : 'secondary'}
                variation={primary ? undefined : 'outlined'}
                tone={primary ? undefined : 'neutral'}
                size={{ xs: 'medium', sm: 'vlarge' }}
                icon={<IconNext />}
                iconGap="small"
            >
                {action}
            </WebButton>
        </div>
    </article>
);

export const Contact: React.FC = () => (
    <section className={`${styles.section} pb-[9rem] pt-[7rem] lg:pb-[12rem] lg:pt-[10rem]`}>
        <Container>
            <div>
                <ContactRow
                    primary
                    title="Potřebujete poradit s Monery?"
                    description="Napište nám, s čím potřebujete pomoci. Dotaz nebo problém vyřešíme přes naši podporu."
                    href={process.env.NEXT_PUBLIC_SUPPORT_NEW_TICKET_URL}
                    icon={<IconGuide />}
                    action="Zadat požadavek"
                />
                <ContactRow
                    title="Přidejte se ke komunitě"
                    description="Proberte své otázky a zkušenosti s ostatními investory na našem Discordu."
                    href="https://discord.gg/n4MYgUh9KF"
                    icon={<IconDiscord />}
                    action="Připojit se na Discord"
                />
                <ContactRow
                    title="Pomozte nám Monery zlepšovat"
                    description="Chybí vám nějaká funkce? Přidejte svůj nápad nebo podpořte návrhy ostatních."
                    href="https://monery.canny.io/"
                    icon={<IconCanny />}
                    action="Navrhnout zlepšení"
                />
            </div>
            <div className="mt-[4rem] flex flex-wrap items-center justify-between gap-[2.4rem]">
                <p className="text-[1.7rem] text-web-copy">Novinky z Monery najdete i na našich sítích.</p>
                <div className="flex flex-wrap gap-[1.2rem]">
                    <WebButton
                        href="https://www.facebook.com/monery.io"
                        variant="secondary"
                        variation="outlined"
                        tone="neutral"
                        size="medium"
                        icon={<IconFacebook />}
                        iconGap="small"
                    >
                        Facebook
                    </WebButton>
                    <WebButton
                        href="https://www.instagram.com/monery.io"
                        variant="secondary"
                        variation="outlined"
                        tone="neutral"
                        size="medium"
                        icon={<IconInstagram />}
                        iconGap="small"
                    >
                        Instagram
                    </WebButton>
                </div>
            </div>
            <div
                className={`${styles.operator} mt-[6rem] grid gap-[2rem] pt-[3.2rem] text-[1.6rem] leading-[1.7] text-web-copy md:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]`}
            >
                <h2 className="text-[2.4rem] font-bold text-brand-secondary leading-[1.3]">Provozovatel</h2>
                <div className="grid gap-[2rem] sm:grid-cols-2">
                    <div>
                        <strong className="text-brand-secondary">Monery Finance s.r.o.</strong>
                        <br />
                        <strong>IČ:</strong> 17060745
                        <br />
                        <strong>DIČ:</strong> CZ17060745
                    </div>
                    <address className="not-italic">
                        Příčná 1892/4
                        <br />
                        110 00 Praha
                    </address>
                </div>
            </div>
        </Container>
    </section>
);
